import { AskedDutyResponse } from 'generated/index';

export const getAskedDutiesByRequestId = (
  askedDuties: AskedDutyResponse[] = [],
  requestId: string | number
): AskedDutyResponse | null => {
  return askedDuties.find(({ duty }) => duty.requestId === +requestId) || null;
};
